<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :saveIsDisabled="!required.filled"
    :active-tab="activeTab"
    :action-type="actionType"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'photos'"
        class="form tab-content"
      >
        <forms-photo-section
          :disabled="readOnly"
          :imagesList="imagesList"
          :previous-images="previousImages"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>

      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Accessories'"
        :accessories-selected="accessoriesSelected"
        :accessories-selected-by-material-id="accessoriesSelectedByMaterialId"
        relation-family-id-select="tb"
        family-id="ac"
        :disabled="readOnly"
      />
      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Others'"
        :accessories-selected="othersSelected"
        :accessories-selected-by-material-id="othersSelectedByMaterialId"
        relation-family-id-select="tb"
        family-id="ot"
        :disabled="readOnly"
      />

      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="field.var_name === 'tp_material_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
          >
            <div>
              <treeselect
                :value="getValueInObject(field.var_name, field.input_type)"
                @input="
                  setValueInObject(field.var_name, $event, field.input_type)
                "
                :options="materialOptions"
                :load-options="loadMaterialOptions"
                :normalizer="materialOptionsNormalizer"
                :disabled="readOnly || field.disable"
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>

          <input-field
            v-else
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :automatic-label="field.has_automatic_label"
            @generateLabel="getAutomaticLabel(autoLabelRequestData)"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            :labelIsLocked="objectData.tp_label_locked"
            :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
            @toggle-label-lock="changeLabelMode"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>
      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import InputField from "../_Molecules/InputField";
import FormsPhotoSection from "../_SpecialTabs/Photos/PhotosForm";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import { bus } from "@/main";
import AccessoriesAndOthersTab from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "TobyBoxForm",

  components: {
    AccessoriesAndOthersTab,
    DynamicObjectFormStructure,
    FormsPhotoSection,
    InputField,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    /**
     */
    linkObjectToPathway: {
      type: Object
    }
  },

  computed: {
    materialRequestQueryParameters() {
      return {
        material_family_id: "tb"
      };
    }
  },

  watch: {
    "objectData.tp_material_id"(newID) {
      this.updateMaterialDependentFields(newID);
    },

    materialOptions() {
      if (this.materialOptions && this.objectData.tp_material_id) {
        this.updateMaterialDependentFields(this.objectData.tp_material_id);
      }
    }
  },

  methods: {
    createObject() {
      this.createDataToSend();

      if (this.$attrs.creatingBulkTP) {
        this.updateObjectLocalStorageData();
        this.closeForm();
        this.$emit("update-tech-point-data", this.dataToSend);
        if (this.$attrs.nextForm) {
          this.$emit("open-next-form");
        }
      } else {
        this.CREATE_OBJECTS({
          endpoint: this.form.endpoint,
          data: [this.dataToSend]
        })
          .then(technicalPointData => {
            if (this.linkObjectToPathway.split) {
              bus.$emit("reset-pathway-and-split-data");
            }

            this.objectData.tp_label = this.incrementLabelSequential(
              this.objectData.tp_label
            );

            this.finishObjectCreation();
            if (this.$attrs.nextForm) {
              this.$emit("open-next-form", {
                createdTechPointData: technicalPointData.data.data[0],
                techPointGeom: this.dataToSend.node.text_geom
              });
            }
          })
          .catch(error => {
            this.$toasted.global.toast_error(error.response.data.data);
            this.loadingSave = false;
          });
      }
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        status: this.objectData.tp_status,
        progress: this.objectData.tp_progress,
        physical_type: "T",
        technical_point_type: "T",
        logical_type: "T" //split - Remove when removed required from back-end
      };
      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }
      this.placeObjectDataInDataToSend();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/TobyBoxForm.vue